var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CreatorEventFulfilledDareStatus, } from 'root/src/shared/dares/creatorEventFulfilledDare.types';
import { memo } from 'react';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { FormProvider, useForm } from 'react-hook-form';
import { CreateDareFormSchema, } from 'root/src/client/web/record/CreatorData/CreatorDare/CreateCreatorDare';
import { zodResolver } from '@hookform/resolvers/zod';
import toast from 'react-hot-toast';
import { getErrorMessage } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { ModalTitle } from 'root/src/client/v2/common/components/modal/ModalTitle';
import { TitleField } from 'root/src/client/v2/_pages/add-campaign/components/AddCampaignForm/DaresStepForm/TitleField';
import { DescriptionField, } from 'root/src/client/v2/_pages/add-campaign/components/AddCampaignForm/DaresStepForm/DescriptionField';
import { FormControl } from '@mui/material';
import { ButtonNew, ButtonNewVariant } from 'root/src/client/v2/common/components/form/ButtonNew';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { useCreatorDaresContext } from 'root/src/client/web/record/CreatorData/CreatorDare/creatorDares.context';
import { BaseTooltip, BaseTooltipContent } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import { Edit } from '@mui/icons-material';
export const EditCreatorDare = memo(({ dare }) => {
    const modal = useModal();
    const { refetch } = useCreatorDaresContext();
    const onEdit = () => {
        modal.show(<EditDareModal onEdit={refetch} dare={dare}/>);
    };
    return (<div className="z-[100] absolute top-4 right-4">
			<BaseTooltip triggerClassName="flex w-full" tooltip={<BaseTooltipContent>Edit Dare</BaseTooltipContent>}>
				<button onClick={onEdit} type="button" className="bg-primary duration-100 rounded-2xl z-10 p-2">
					<Edit />
				</button>
			</BaseTooltip>
		</div>);
});
const EditDareModal = memo(({ dare, onEdit }) => {
    const modal = useModal();
    const form = useForm({
        resolver: zodResolver(CreateDareFormSchema),
        defaultValues: {
            title: dare.title,
            description: dare.description,
        },
    });
    const editMutation = trpc.dares.updateEventFulfilledDare.useMutation();
    const onDisable = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield editMutation.mutateAsync({
                id: dare.id,
                status: CreatorEventFulfilledDareStatus.Disabled,
            });
            yield onEdit();
            toast.success('Dare disabled');
            modal.hide();
        }
        catch (err) {
            toast.error(getErrorMessage(err));
        }
    });
    const onSubmit = form.handleSubmit((data) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield editMutation.mutateAsync(Object.assign({ id: dare.id }, data));
            yield onEdit();
            toast.success('Dare updated successfully');
            modal.hide();
        }
        catch (err) {
            toast.error(getErrorMessage(err));
        }
    }));
    return (<ModalLayout className="flex flex-col gap-12">
			<ModalTitle className="capitalize">Edit Dare</ModalTitle>
			<FormProvider {...form}>
				<form className="flex flex-col gap-4" onSubmit={onSubmit}>
					<TitleField />
					<DescriptionField />
					<FormControl>
						<ButtonNew disabled={form.formState.isSubmitting} className="flex items-center justify-center" type="submit">
							{(form.formState.isSubmitting)
            && <LoadingCircles className="flex flex-initial mr-2" width={20} height={20}/>}
							Save Changes
						</ButtonNew>
					</FormControl>
				</form>
			</FormProvider>
			<ButtonNew onClick={onDisable} variant={ButtonNewVariant.Error} disabled={editMutation.isPending} className="flex items-center justify-center">
				{editMutation.isPending && <LoadingCircles className="flex flex-initial mr-2" width={20} height={20}/>}
				Disable
			</ButtonNew>
		</ModalLayout>);
});
